import { ValueObject } from '@/engine/core/valueObject';
import type { IViewPortOrientation } from '../../interfaces';
import type { IReportConfigScreenshotSceneItemEntry, ISceneScreenshotConfigProps } from './interfaces';
import type * as THREE from 'three';
import type { SliceType } from '../images/interfaces';
import type { OrientationPresetType } from '@/engine/app/modules/reporting/ReportConfigBuilder';

/**
 * Represents a value object for scene screenshot configuration in a report.
 */
export class ReportConfigSceneScreenshotValue extends ValueObject<ISceneScreenshotConfigProps> {
  public constructor(props: ISceneScreenshotConfigProps) {
    super(props);
  }

  public get descriptor(): string {
    return this.props.descriptor;
  }

  public get phase(): string | undefined {
    return this.props.phase;
  }

  public get viewportDescriptor(): string {
    return this.props.viewportDescriptor;
  }

  public get viewDescriptor(): string | undefined {
    return this.props.viewDescriptor;
  }

  public get step(): string | undefined {
    return this.props.step;
  }

  public get syncImagesPoint(): THREE.Vector3 | undefined {
    return this.props.syncImagesPoint;
  }

  public get items(): Array<IReportConfigScreenshotSceneItemEntry> | undefined {
    return this.props.items;
  }

  public get dimensions(): { width: number; height: number } | undefined {
    return this.props.dimensions;
  }

  public get orientation(): IViewPortOrientation | undefined {
    return this.props.orientation;
  }

  public get orientationByPreset(): OrientationPresetType | undefined {
    return this.props.orientationByPreset;
  }

  public get sliceOrientation(): { sliceType: SliceType; orientationByPreset: OrientationPresetType } | undefined {
    return this.props.sliceOrientation;
  }

  public get viewRoi(): { locationDescriptor: string; zoomFactor: number } | undefined {
    return this.props.viewRoi;
  }

  public get viewRoiOffset(): { locationDescriptor: string } | undefined {
    return this.props.viewRoiOffset;
  }

  public get absoluteDimensions(): { width: number; height: number } | undefined {
    return this.props.dimensions
      ? {
          width: this.props.dimensions.width * this.props.dpi,
          height: this.props.dimensions.height * this.props.dpi
        }
      : undefined;
  }

  public get dpi(): number {
    return this.props.dpi;
  }
}
